import { gql } from 'urql';

export const STOCK_DASHBOARD_UBICACIONES = gql`
  query StockDashboardUbicaciones {
    stockUbicaciones {
      id nombre zona rack nivel capacidadPosiciones posicionesOcupadas posicionesLibres articulosActivos bultosActuales
    }
  }
`;

export const STOCK_DASHBOARD_MOVIMIENTOS = gql`
  query StockDashboardMovimientos($filter: StockMovimientoFilter) {
    stockMovimientos(filter: $filter) {
      items { id tipo fecha hora cliente remito usuario cantidadTotal detalles { cantidad } }
      total page pageSize
    }
  }
`;
